export default __webpack_public_path__ + "static/media/Path3424.d6398b92.svg";